import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../views/HomePage.vue";
import SofieOrderSearch from "@/views/Sofie/OrderSearch.vue";
import SofieTrackingDetail from "@/views/Sofie/TrackingDetail.vue";
import AlcoOrderSearch from "@/views/Alco/OrderSearch.vue";
import AlcoTrackingDetail from "@/views/Alco/TrackingDetail.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/sofie",
    name: "SofieOrderSearch",
    component: SofieOrderSearch,
  },
  {
    path: "/sofie/:id*",
    name: "SofieTrackingDetail",
    component: SofieTrackingDetail,
  },
  {
    path: "/alco",
    name: "AlcoOrderSearch",
    component: AlcoOrderSearch,
  },
  {
    path: "/alco/:id",
    name: "AlcoTrackingDetail",
    component: AlcoTrackingDetail,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

export default router;
